module.exports = __webpack_public_path__ + "img/velcar.4788bd82.jpg";